import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';

const root = window || {};

root._ = _;
Backbone.$ = $;
root.$ = $;
root.jQuery = $;

export default Backbone;
